class PaymentMethodsHelper {
    public getLogo(method: string): string {
        return `/img/methods/${method}.png`;
    }
}

export const paymentMethodsHelper = new PaymentMethodsHelper();
